import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './views/home/home.component';
import { FlashBeepComponent } from './views/flash-beep/flash-beep.component';
import { InfoComponent } from './views/info/info.component';
import { PasswordResetComponent } from './views/password-reset/password-reset.component';
import { ScreenResolutionComponent } from './views/screen-resolution/screen-resolution.component';
import { RegistrationFormComponent } from './views/register/participantUser/registrationForm/registrationForm.component';
import { CompleteRegisterComponent } from './views/register/universityUser/completeRegister/completeRegister.component';
import { SuccessRegistrationComponent } from './views/register/participantUser/successRegistration/successRegistration.component';
import { UniRegistrationFormComponent } from './views/register/universityUser/uniRegistrationForm/uniRegistrationForm.component';
import { LogOnComponent } from './views/logOn/logOn.component';
import { InviteRegisterComponent } from './views/invite-register/invite-register.component';
import { MemoryExperimentComponent } from './views/memory-experiment/memory-experiment.component';
import { LoudnessPerceptionComponent } from './views/loudness-perception/loudness-perception.component';
import { TargetDetectionComponent } from './views/target-detection/target-detection.component';
import { ExperimentDataComponent } from './views/experimentData/experimentData.component';
import { AuthService } from './service/auth.service';
import { UniUserService } from './service/uniUser.service';
import { ResetPasswordComponent } from './views/password-reset/reset-password/resetPassword/resetPassword.component';
import { QuestionnaireComponent } from './views/questionnaire/questionnaire.component';
import { MovementPerceptionComponent } from './views/movement-perception/movement-perception.component';
import { PersonalitySurveyComponent } from './views/personality-survey/personality-survey.component';
import { ResendLinkComponent } from './views/resend-link/resend-link.component';

import { AdminAreaComponent } from './views/admin-area/admin-area.component';
import { CaptchaComponent } from './views/captcha/captcha-area.component';
import { CaptchaService } from './service/captcha.service';

const routes: Routes = [
  { path: '', component: HomeComponent, canActivate: [CaptchaService] },
  { path: 'captcha', component: CaptchaComponent },
  { path: 'flash-beep', component: FlashBeepComponent, canActivate: [AuthService] },
  { path: 'info', component: InfoComponent, canActivate: [AuthService] },
  { path: 'password-reset', component: PasswordResetComponent },
  { path: 'screen-measurement', component: ScreenResolutionComponent },
  { path: 'register', component: RegistrationFormComponent },
  { path: 'uni/register', component: UniRegistrationFormComponent, canActivate: [UniUserService] },
  { path: 'uni/register/complete/:token', component: CompleteRegisterComponent },
  { path: 'register/success/:token', component: SuccessRegistrationComponent },
  { path: 'reset-password/:token', component: ResetPasswordComponent },
  { path: 'logon', component: LogOnComponent },
  { path: 'inviteToRegister', component: InviteRegisterComponent },
  { path: 'logon/:admin', component: LogOnComponent },
  { path: 'uniUser/logon', component: LogOnComponent },
  { path: 'personality-survey', component: PersonalitySurveyComponent, canActivate: [AuthService] },
  { path: 'memory-experiment', component: MemoryExperimentComponent, canActivate: [AuthService] },
  { path: 'loudness-perception', component: LoudnessPerceptionComponent, canActivate: [AuthService] },
  { path: 'target-detection', component: TargetDetectionComponent, canActivate: [AuthService] },
  { path: 'uni/data', component: ExperimentDataComponent, canActivate: [UniUserService] },
  { path: 'questionnaire', component: QuestionnaireComponent, canActivate: [AuthService] },
  { path: 'movement-perception', component: MovementPerceptionComponent, canActivate: [AuthService] },
  { path: 'resend-link', component: ResendLinkComponent},
  { path: 'admin-area', component: AdminAreaComponent},
  { path: '**', redirectTo: '/'}

];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
